import { lazy } from "react";
import ProtectedRouteCustomer from "./ProtectCustomerRoute";

const DeleteAccountPageCustomer = lazy(() => import("../pages/customer/auth/DeleteAccount"));
const CustomerSendOtp = lazy(() => import("../pages/customer/auth/SendOtpCustomer"));
const CustomerVerifyOtp = lazy(() => import("../pages/customer/auth/VerifyOtpCustomer"));

export const customerRoutes = [
        // customer pages
    {path:"/customer/delete-account" ,element :<ProtectedRouteCustomer><DeleteAccountPageCustomer/></ProtectedRouteCustomer>},
    {path:"/customer/sendOtp" , element:<CustomerSendOtp/>},
    {path:"/customer/verify-otp" , element:<CustomerVerifyOtp/>},
]